<template>
  <b-modal
    v-model="visible"
    modal-class="mfa-hotline-modal"
    @hide="emitClose"
  >
    <template #modal-title>
      <h3>
        <slot name="txtHeadline"></slot>
      </h3>
    </template>
    <div class="mfa-hotline-modal--group">
      <span class="mfa-hotline-modal--title">
        <slot name="txtTitleDescription"></slot>
      </span>
      <span class="mfa-hotline-modal--desc">
        <slot name="txtDescription"></slot>
      </span>
    </div>
    <template #modal-footer>
      <b-button class="mfa-hotline-button" variant="secondary" @click="emitClose">
        <slot name="btnClose">Schließen</slot>
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'MfaHotline',
  props: [],
  data () {
    return {
      visible: true
    }
  },
  methods: {
    emitClose () {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>
